module.exports = __webpack_public_path__ + "static/media/cloudy.ad789581.svg";